import React from 'react';
import './UPAnnouncements.less';

export default function AnnouncementCloseButton({ onClick, label = 'Dismiss extension announcement', title }) {
  return (
    <button type="button" styleName="close" onClick={onClick} aria-label={label} title={title}>
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
        <path d="M3 3l18 18M21 3L3 21" stroke="currentColor" strokeWidth="2.25" strokeLinecap="round" />
      </svg>
    </button>
  );
}
